import { Moment } from "moment";
import { PaginationInquiry } from "../../../../helper/pagination";
import { Action } from "../../customer/entity/customer.model";
import { User } from "../../user/entity/user.model";

export interface TaskBase {
  uuid?: string;
  username: string;
  taskType?: string;
  customer?: string;
  status?: TaskStatus;
  stalls: Stall[];
  description: string;
}

export interface Task extends TaskBase {
  date?: string;
}

export interface TaskFilter extends PaginationInquiry {
  username?: string;
  date?: string;
  taskType?: string;
  status?: string;
  routeId?: string;
}

export interface TaskUI extends TaskBase {
  key?: number;
  index?: number;
  actions?: Action[];
  date?: Moment;
  image?: string[];
}

export enum TaskStatus {
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  NEW = "NEW",
  DECLINED = "DECLINED",
  APPROVED = "APPROVED",
}

export interface Stall {
  uuid?: string;
  beforeImagePath: string;
  afterImagePath: string;
  beforeImageFile: string;
  afterImageFile: string;
  createdDate?: string;
  updatedDate?: string;
}

export interface ImagePath {
  before?: string;
  after?: string;
}

export interface Assignment {
  index: number;
  uuid: string;
  createdDate: Date;
  createdMoment: Moment;
  createdBy: string;
  username: string;
  assignedDate: Date;
  assignedMoment: Moment;
  status: string;
  title: string;
  description: string;
  user?: User;
  routeId: string;
}

export interface AssignmentFilter extends PaginationInquiry {
  username?: string;
  date?: string;
  routeId?: string;
}
